import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { PropsWithChildren, useCallback, useRef } from "react";

interface Props {
  isOpen: boolean;
  title?: string;
  icon?: React.ReactNode;
  onConfirm: (confirmed: boolean) => void;
}

export function ConfirmDestructiveActionDialog({
  isOpen,
  title = "Verwijderen bevestigen",
  icon = null,
  onConfirm,
  children,
}: PropsWithChildren<Props>) {
  const leastDestructiveRef = useRef<HTMLButtonElement>(null);
  const { onClose } = useDisclosure();

  const confirm = useCallback(
    (confirmed: boolean) => {
      onConfirm(confirmed);
      onClose();
    },
    [onConfirm, onClose],
  );

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={leastDestructiveRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader
            alignItems="center"
            data-testid="confirm-destructive-action-dialog-header"
            display="flex"
            fontSize="lg"
            fontWeight="bold"
          >
            {icon}
            <Text>{title}</Text>
          </AlertDialogHeader>

          <AlertDialogBody data-testid="confirm-destructive-action-dialog-body">
            {children}
          </AlertDialogBody>

          <AlertDialogFooter data-testid="confirm-destructive-action-dialog-footer">
            <Button colorScheme="red" onClick={() => confirm(true)}>
              Ja
            </Button>
            <Button
              ref={leastDestructiveRef}
              ml={3}
              onClick={() => confirm(false)}
              variant="ghost"
            >
              Nee
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
